import { render, staticRenderFns } from "./etf.vue?vue&type=template&id=2dbb643c&scoped=true"
import script from "./etf.vue?vue&type=script&lang=js"
export * from "./etf.vue?vue&type=script&lang=js"
import style0 from "./etf.vue?vue&type=style&index=0&id=2dbb643c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbb643c",
  null
  
)

export default component.exports